import React from 'react';
import { Card, CardContent, CardHeader } from './card';

export const SkeletonCard = ({ lines = 3, showHeader = true, className = '' }) => {
  return (
    <Card className={`card-base animate-pulse ${className}`}>
      {showHeader && (
        <CardHeader className="pb-2">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-lg bg-muted/50" />
            <div className="h-5 w-32 bg-muted/50 rounded" />
          </div>
        </CardHeader>
      )}
      <CardContent className="space-y-3">
        {Array.from({ length: lines }).map((_, i) => (
          <div 
            key={i} 
            className="h-4 bg-muted/50 rounded" 
            style={{ width: `${100 - (i * 15)}%` }}
          />
        ))}
      </CardContent>
    </Card>
  );
};

export const SkeletonProfile = () => (
  <Card className="card-base animate-pulse">
    <CardContent className="p-4 sm:p-6">
      <div className="flex items-start gap-4">
        <div className="h-16 w-16 rounded-full bg-muted/50" />
        <div className="flex-1 space-y-3">
          <div className="h-5 w-40 bg-muted/50 rounded" />
          <div className="h-4 w-24 bg-muted/50 rounded" />
          <div className="h-3 w-full bg-muted/50 rounded" />
        </div>
      </div>
    </CardContent>
  </Card>
);

export const SkeletonNavGrid = () => (
  <div className="grid grid-cols-4 gap-3 animate-pulse">
    {Array.from({ length: 8 }).map((_, i) => (
      <div key={i} className="h-20 rounded-lg bg-muted/30 border border-border" />
    ))}
  </div>
);

export const SkeletonLeaderboard = () => (
  <Card className="card-base animate-pulse">
    <CardHeader className="pb-2">
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 rounded-lg bg-muted/50" />
        <div className="h-5 w-36 bg-muted/50 rounded" />
      </div>
    </CardHeader>
    <CardContent className="space-y-3">
      {Array.from({ length: 3 }).map((_, i) => (
        <div key={i} className="flex items-center gap-3 p-2">
          <div className="w-10 h-10 rounded-full bg-muted/50" />
          <div className="flex-1 space-y-2">
            <div className="h-4 w-24 bg-muted/50 rounded" />
            <div className="h-3 w-16 bg-muted/50 rounded" />
          </div>
          <div className="w-8 h-8 rounded-full bg-muted/50" />
        </div>
      ))}
    </CardContent>
  </Card>
);

export default SkeletonCard;
